import axios from "axios";
import store from "@/store";
import helper from "@/helpers/helper";

export default {
    async refreshToken () {
      if (!store.state.auth || !store.state.auth.jwtPayload || !store.state.auth.accessToken){
        return null;
      }

      let data = {
        id: store.state.auth.jwtPayload.user_id,
        access_token: store.state.auth.accessToken,
        refresh_token: store.state.auth.jwtPayload.jwt_refresh_token
      }

      try {
        const response = await axios.post('/users/token/refresh', data, { skipAuthRefresh: true });
        const resBody = response?.data || {};
        const resData = resBody.data || resBody;
        const newToken =
          resData?.user?.access_token ||
          resData?.access_token ||
          resBody?.access_token ||
          resBody?.user?.access_token;

        if (newToken) {
          store.commit("auth/setAccessToken", newToken);
          try {
            const decoded = helper.parseJwt(newToken);
            if (decoded) {
              store.commit("auth/setJwtPayload", decoded);
            }
          } catch (e) {
            // Ignore decode error
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + newToken;
          return newToken;
        } else {
          const exp = store.state.auth.jwtPayload?.exp;
          const isStillValid = exp && (exp * 1000 > Date.now());
          if (!isStillValid) {
            store.commit('auth/setTokenExpires');
            store.dispatch('auth/logout', { logoutAuth: true });
          }
          return null;
        }
      } catch (err) {
        const exp = store.state.auth.jwtPayload?.exp;
        const isStillValid = exp && (exp * 1000 > Date.now());
        if (!isStillValid) {
          store.commit('auth/setTokenExpires');
          store.dispatch('auth/logout', { logoutAuth: true });
        }
        return null;
      }
    },
  }